import { Button, Flex, Typography } from "antd";
import { redirectToPayment } from "lib/paymentRedirect";
import { useIntl } from "react-intl";

export const ContinueTransaction = ({ url, onDiscard }: { url: string; onDiscard: () => void }) => {
  const { formatMessage } = useIntl();
  return (
    <Flex vertical align="center">
      <Typography.Title level={3}>
        {formatMessage({
          defaultMessage: "Dokończ płatność",
          id: "YlxOP3",
        })}
      </Typography.Title>
      <Typography.Text>
        {formatMessage({
          defaultMessage:
            "Masz już rozpoczęty proces umawiania wizyty, której szczegóły znajdują się na Twoim mailu. Możesz przejść do płatności i go dokończyć lub rozpocząć od nowa",
          id: "+jnnuM",
        })}
      </Typography.Text>
      <Flex style={{ marginTop: 20 }} justify="space-around">
        <Button style={{ marginRight: 20 }} onClick={onDiscard}>
          {formatMessage({ defaultMessage: "Rozpocznij od nowa", id: "ouhH9g" })}
        </Button>
        <Button type="primary" onClick={() => redirectToPayment({ paymentLink: url })}>
          {formatMessage({ defaultMessage: "Przejdź do płatności", id: "ztxeTX" })}
        </Button>
      </Flex>
    </Flex>
  );
};
